/**
 * Service: discountsApi
 */
angular.module('acme.common.service.discountsApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('DiscountsApiService', [ '$http', '$q', 'ApiVersionFactory', 'QueryStringBuilderFactory', function($http, $q, ApiVersionFactory, QueryStringBuilderFactory) {

    return{

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/discounts';
        return true;
      },

      list: function(version, props) {
        var apiVersion = new ApiVersionFactory(),
            q = '';

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: apiVersion.init({url: this.service + q, version: version || 'v1'})
        });
      },

      detail: function(id) {

        return $http({
          method: 'get',
          url: this.service + '/' + id
        });

      },

      create: function(props) {

        return $http({
          method: 'post',
          url: this.service,
          data: {
            name: props.name,
            code: props.code,
            values: props.values,
            description: props.description
          }
        });

      },

      update: function(props) {

        return $http({
          method: 'put',
          url: this.service + '/' + props.id,
          data: {
            id: props.id,
            name: props.name,
            code: props.code,
            values: props.values,
            description: props.description
          }
        });

      },

      preview: function(props) {

        return $http({
          method: 'get',
          url: this.service + '/' + props.discountId + '/price/list/' + props.priceListId
        });

      },

      remove: function(id) {
        return $http({
          method: 'delete',
          url: this.service + '/' + id
        });
      }

    };

}]);